import React, { useState, useEffect } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import classNames from 'classnames'
import qs from 'qs'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import Select from '~components/ui/Select'
import ProductMatrix from '~components/shop/ProductMatrix'
import { sortBy } from 'lodash'

const MatrixOverlay = ({
  products,
  product: initialProduct,
  colours,
  toggleOverlay,
  overlay
}) => {
  const { range } = useParams()
  const location = useLocation()
  const rangeProducts = products[range]
  const [product, setProduct] = useState(null)
  const [selectedColour, setSelectedColour] = useState('')

  useEffect(() => setProduct(initialProduct), [initialProduct])
  useEffect(() => setDefaultColour(), [location])

  const getImage = () => {
    const images = sortBy(product?.images, 'sort_order')
    return images.length ? images[0].url_thumbnail : ''
  }

  const getColours = () => {
    return colours.reduce((carry, colour) => {
      carry.push({
        value: colour.code,
        name: colour.name
      })
      return carry
    }, [])
  }

  const handleColourChange = (e) => {
    const newProduct = rangeProducts.find(p => p.custom_fields.style_code === product.custom_fields.style_code && p.custom_fields.colour_code === e.target.value)
    if (!newProduct) return
    setProduct(newProduct)
    setSelectedColour(e.target.value)
  }

  const setDefaultColour = () => {
    const colours = getColours()
    const query = qs.parse(location.search, { ignoreQueryPrefix: true })
    const defaultColour = colours.find(c => c.code === query.colour)?.code || colours[0]?.code
    setSelectedColour(defaultColour)
  }

  return (
    <>
      {product && (
        <div className={classNames('fixed w-full h-full top-0 left-0 right-0 bg-white z-50 overflow-scrolling overflow-y-scroll', { hidden: !overlay })}>
          <div className="w-full h-22.25 flex items-center bg-lightGrey border-coral border-b">
            <div className="flex items-stretch">
              <div className="w-16.5">
                <button type="button" aria-label="Close" onClick={toggleOverlay} className="block relative h-0 pt-portrait w-full">
                  <img src={getImage()} alt={product.name} className="absolute top-0 left-0 right-0 block w-full h-full object-cover" />
                </button>
              </div>

              <div className="pl-3 pt-4">
                <span className="block text-xxs">
                  #
                  {product.custom_fields.style_code}
                </span>

                <span className="block">
                  {product.name}
                </span>
              </div>
            </div>

            <button type="button" className="ml-auto h-full flex items-center border-coral border-l px-3" aria-label="Close" onClick={toggleOverlay}>
              <span aria-hidden="true" className="w-4 h-4 block">
                <Sprite name="cross" />
              </span>
            </button>
          </div>

          <div className="mt-4">
            <div className="xxl:container mx-auto px-4 md:px-8 xxl:px-0">
              <Select
                items={getColours()}
                value={selectedColour}
                className="w-full"
                onChange={(e) => handleColourChange(e)}
              />
            </div>
          </div>

          <div className="mt-4 overflow-x-auto w-full">
            <ProductMatrix key={product.id} product={product} mobile={true} />
          </div>
        </div>
      )}
    </>
  )
}

MatrixOverlay.propTypes = {
  product: PropTypes.object,
  products: PropTypes.object,
  colours: PropTypes.array,
  toggleOverlay: PropTypes.func.isRequired,
  overlay: PropTypes.bool.isRequired
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  products: state.shop.products
})

export default connect(mapStateToProps)(MatrixOverlay)
